export default __webpack_public_path__ + "static/yzny-logo-h-black-3e07a3d725e276d10157d1f4df74aa59.svg";